module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-1440w.2cf16ca8.jpg";